import { Navigate, RouteObject } from 'react-router-dom'

import ApartPage from '@/features/apart/pages/ApartPage'
import CancelPage from '@/features/cancel/pages/CancelPage'
import JoinPartnerPage from '@/features/join/pages/JoinPartnerPage'
import JoinSuccessPage from '@/features/join/pages/JoinSuccessPage'
import MypagePage from '@/features/mypage/pages/MypagePage'
import QrPage from '@/features/qr/pages/QrPage'
import StickerPage from '@/features/sticker/pages/StickerPage'
import FaqListPage from '@/features/support/faq/pages/FaqListPage'
import NewsListPage from '@/features/support/news/pages/NewsListPage'
import NoticeDetail from '@/features/support/notice/pages/NoticeDetailPage'
import NoticeListPage from '@/features/support/notice/pages/NoticeListPage'
import QnaPage from '@/features/support/qna/pages/QnaPage'
import RefundPage from '@/features/support/refund/pages/RefundPage'
import SupportPage from '@/features/support/SupportPage'
import TermsPage from '@/features/terms/pages/TermsPage'
import UsagePage from '@/features/usage/pages/UsagePage'
import { PageLayout } from '@/shared/components/layout'

const pageRoutes: RouteObject = {
  element: <PageLayout />,
  children: [
    {
      path: 'join',
      element: <JoinPartnerPage />,
    },
    {
      path: 'b2b/terms/:termsIdx',
      element: <ApartPage />,
    },
    {
      path: 'success',
      element: <JoinSuccessPage />,
    },
    {
      path: 'usage',
      element: <UsagePage />,
    },
    {
      path: 'sticker',
      element: <StickerPage />,
    },
    {
      path: 'qr',
      element: <QrPage />,
    },
    {
      element: <SupportPage />,
      children: [
        {
          path: 'notice',
          element: <NoticeListPage />,
        },
        {
          path: 'noticeDetail/:detailIdx',
          element: <NoticeDetail />,
        },
        {
          path: 'news',
          element: <NewsListPage />,
        },
        {
          path: 'faq',
          element: <FaqListPage />,
        },
        {
          path: 'qna',
          element: <QnaPage />,
        },
        {
          path: 'refund',
          element: <Navigate to="/refund/0" replace />,
        },
        {
          path: 'refund/:telecomCode',
          element: <RefundPage />,
        },
      ],
    },
    {
      path: 'mypage',
      element: <MypagePage />,
    },
    {
      path: 'cancel',
      element: <CancelPage />,
    },
    {
      path: 'terms/:telecom/:termsIdx',
      element: <TermsPage />,
    },
  ],
}
export default pageRoutes
